"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdsPerformanceStatExtendedCard = exports.AdsPerformanceStatCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const stat_card_1 = require("../stat/stat-card");
const stat_extended_card_1 = require("../stat/stat-extended-card");
const ads_texts_1 = require("../../utils/ads-texts");
const string_case_1 = require("../../utils/string-case");
const AdsPerformanceStatCard = props => {
    var _a, _b;
    const titleText = (_a = props.title) !== null && _a !== void 0 ? _a : string_case_1.camelCaseToTitleCase(props.stat);
    const hintText = (_b = props.description) !== null && _b !== void 0 ? _b : ads_texts_1.adsStatDescriptions[props.stat];
    return jsx_runtime_1.jsx(stat_card_1.StatCard, Object.assign({}, props, { title: titleText, description: hintText }), void 0);
};
exports.AdsPerformanceStatCard = AdsPerformanceStatCard;
const AdsPerformanceStatExtendedCard = props => {
    var _a, _b;
    const titleText = (_a = props.title) !== null && _a !== void 0 ? _a : string_case_1.camelCaseToTitleCase(props.stat);
    const hintText = (_b = props.description) !== null && _b !== void 0 ? _b : ads_texts_1.adsStatDescriptions[props.stat];
    return jsx_runtime_1.jsx(stat_extended_card_1.StatExtendedCard, Object.assign({}, props, { title: titleText, description: hintText }), void 0);
};
exports.AdsPerformanceStatExtendedCard = AdsPerformanceStatExtendedCard;
//# sourceMappingURL=ads-stat.js.map